module.exports = __webpack_public_path__ + "static/media/progger6.9ecdc0c3.png";